import React from "react";
import { IconProp } from ".";
export default function InfoIcon(props: IconProp) {
    const { width = 38, height = 31, color } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 16" fill="none">
            <g clipPath="url(#clip0_2435_4935)">
                <path
                    d="M8.75 2H10C11.1031 2 12 2.89688 12 4V14C12 15.1031 11.1031 16 10 16H2C0.896875 16 0 15.1031 0 14V4C0 2.89688 0.896875 2 2 2H3.25H3.55C3.78125 0.859375 4.79062 0 6 0C7.20938 0 8.21875 0.859375 8.45 2H8.75ZM2 3.5C1.725 3.5 1.5 3.725 1.5 4V14C1.5 14.275 1.725 14.5 2 14.5H10C10.275 14.5 10.5 14.275 10.5 14V4C10.5 3.725 10.275 3.5 10 3.5H9.5V4.25C9.5 4.66563 9.16563 5 8.75 5H6H3.25C2.83437 5 2.5 4.66563 2.5 4.25V3.5H2ZM6 3.25C6.19891 3.25 6.38968 3.17098 6.53033 3.03033C6.67098 2.88968 6.75 2.69891 6.75 2.5C6.75 2.30109 6.67098 2.11032 6.53033 1.96967C6.38968 1.82902 6.19891 1.75 6 1.75C5.80109 1.75 5.61032 1.82902 5.46967 1.96967C5.32902 2.11032 5.25 2.30109 5.25 2.5C5.25 2.69891 5.32902 2.88968 5.46967 3.03033C5.61032 3.17098 5.80109 3.25 6 3.25Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_2435_4935">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
